module.exports = __webpack_public_path__ + "static/media/vitaminsBox.78779017.png";